module.exports = {"pageTitleText":"告警规则","createText":"创建规则","ruleName":"规则名称","alertRuleQuery":"Query","alertChannelName":"通知对象","alertValue":"告警阀值","alertValueUnit":"阀值单位","isAlerting":"触发状态","currentValue":"当前数值","alertMessage":"告警信息","alertWhen":"高于/低于","alertValueInfo":"告警值","ruleTest":"測試","sections":{"essential":"基础"}}


//////////////////
// WEBPACK FOOTER
// ./src/i18n/zh-CN/alertrules.json
// module id = X7Mz
// module chunks = 3